import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "clearcontainer" }
const _hoisted_2 = ["placeholder", "value"]


import { LControl } from "@vue-leaflet/vue-leaflet";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClearableInput',
  props: {
  modelValue: String,
  placeholder: String,
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props





const updateValue = (val: string) => {
  emit("update:modelValue", val);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LControl), { class: "leaflet-control" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          class: "searchbox",
          type: "text",
          maxlength: "3",
          inputmode: "numeric",
          placeholder: props.placeholder,
          value: props.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (updateValue(($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_2),
        _createElementVNode("a", {
          href: "#",
          class: "circle",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateValue(``)))
        }, "X")
      ])
    ]),
    _: 1
  }))
}
}

})